import Head from "next/head";
import { OnboardingShellV3 } from "@medbillai/app/screens/onboarding-v3";
import { SignUpOnboardingLayout } from "@medbillai/app/screens/sign-up-onboarding/layout.web";
import { withLaunchDarklyFlags } from "../utils/flag-bootstrap";
import { OnboardingPageTransition } from "../utils/transition/OnboardingPageTransition";
import { SlidingLayout } from "../utils/transition/SlidingLayout";
import type { NextPageWithLayout } from "./_app";
export const getServerSideProps = withLaunchDarklyFlags();
export const Page: NextPageWithLayout = () => <>
    <Head data-sentry-element="Head" data-sentry-source-file="get-started.tsx">
      <title>Get Started</title>
    </Head>
    <OnboardingShellV3 phase="preauth" Transition={OnboardingPageTransition} data-sentry-element="OnboardingShellV3" data-sentry-source-file="get-started.tsx" />
  </>;
Page.getLayout = page => <SignUpOnboardingLayout>
    <SlidingLayout>{page}</SlidingLayout>
  </SignUpOnboardingLayout>;
export default Page;